import { createWithEqualityFn } from "zustand/traditional";
import { createJSONStorage, persist } from "zustand/middleware";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { isWeb } from "@companion-core/shared/app/Utils/platform";
import { APIUniverse } from "@companion-core/shared/app/Interfaces/API";

interface OnboardingState {
  geolocationAlreadyRequested: boolean;
  geolocationGranted: boolean;
  tags: string[] | undefined;
  universe: APIUniverse | undefined;
  contentFilters: string | undefined;
}

interface OnboardingActions {
  setGeolocationAlreadyRequested: (geolocationAlreadyRequested: boolean) => void;
  setGeolocationGranted: (geolocationGranted: boolean) => void;
  setTags: (tags: string[] | undefined) => void;
  setUniverse: (universe: APIUniverse | undefined) => void;
  setContentFilters: (contentFilters: string | undefined) => void;
}

export const initialState: OnboardingState = {
  geolocationAlreadyRequested: false,
  geolocationGranted: false,
  tags: undefined,
  universe: undefined,
  contentFilters: undefined,
};

export const useOnboardingStore = createWithEqualityFn<OnboardingState & OnboardingActions>()(
  persist(
    (set) => ({
      ...initialState,
      setGeolocationAlreadyRequested: (geolocationAlreadyRequested: boolean) =>
        set({ geolocationAlreadyRequested }),
      setGeolocationGranted: (geolocationGranted: boolean) => set({ geolocationGranted }),
      setTags: (tags: string[] | undefined) => set({ tags }),
      setUniverse: (universe: APIUniverse | undefined) => set({ universe }),
      setContentFilters: (contentFilters: string | undefined) => set({ contentFilters }),
    }),
    {
      name: "onboarding-storage",
      storage: createJSONStorage(() => (isWeb() ? localStorage : AsyncStorage)),
      partialize: (state) => ({
        geolocationAlreadyRequested: state.geolocationAlreadyRequested,
        geolocationGranted: state.geolocationGranted,
        tags: state.tags,
        universe: state.universe,
        contentFilters: state.contentFilters,
      }),
    }
  )
);
